const DEFAULT_BLOCK_SIZES = 30;
const DEFAULT_BLOCK_SIZES_2 = 70;

export const COLOR_PALETTE = {
  BRAND: [
    undefined,
    '#E6F4FF',
    '#B5DBFF',
    '#8CC4FF',
    '#63A9FF',
    '#3B8CFF',
    '#1068F4',
    '#044BCF', // 7
    '#0035A8',
    '#002582',
    '#00175C',
  ],
  GRAY: [
    undefined,
    '#FFFFFF',
    '#F6F8FB',
    '#F4F6F9',
    '#EDF0F4',
    '#D0D5DD',
    '#98A2B3',
    '#667085',
    '#475467',
    '#2F3C4C',
    '#12171D',
  ],
  BLUE: [
    undefined,
    '#EFF8FF',
    '#D1E9FF', //2
    '#B2DDFF',
    '#84CAFF',
    '#53B1FD',
    '#2E90FA',
    '#1570EF', //7
    '#175CD3',
    '#1849A9',
    '#194185',
  ],
  RED: [
    undefined,
    '#FEF3F2',
    '#FEE4E2',
    '#FECDC9',
    '#FDA19B',
    '#F97066',
    '#F04438',
    '#D92D20',
    '#B32318',
    '#912018',
    '#7A271A',
  ],
  ORANGE: [
    undefined,
    '#FFFAEB',
    '#FEEFC6',
    '#FEDF89',
    '#FEC84B',
    '#FDB022',
    '#F79009',
    '#DC6803', //7
    '#B54708',
    '#93370D',
    '#792E0D',
  ],
  GREEN: [
    undefined,
    '#ECFDF3',
    '#D1FADF',
    '#A6F4C5',
    '#6CE9A6',
    '#32D583',
    '#12B76A',
    '#039855', //7
    '#027A48',
    '#05603A',
    '#054F31',
  ],
  BLUE_GRAY: [
    undefined,
    '#F8F9FC',
    '#EAECF5',
    '#D5D9EB',
    '#AFB5D9',
    '#717BBC',
    '#4E5BA6',
    '#3E4784',
    '#363F72',
    '#293056',
    '#101323',
  ],
  LIME: [
    undefined,
    '#FCFFE6',
    '#F4FFB8',
    '#EAFF8F',
    '#D3F261',
    '#BAE637',
    '#A0D911',
    '#7CB305',
    '#5B8C00',
    '#3F6600',
    '#254000',
  ],
  CYAN: [
    undefined,
    '#E6FFFB',
    '#B5F5EC',
    '#87E8DE',
    '#5CDBD3',
    '#36CFC9',
    '#13C2C2',
    '#08979C',
    '#006D75',
    '#00474F',
    '#002329',
  ],
  PURPLE: [
    undefined,
    '#F4F3FF',
    '#EBE9FE',
    '#D9D6FE',
    '#BDB4FE',
    '#9B8AFB',
    '#7A5AF8',
    '#6938EF',
    '#5925DC',
    '#4A1FB8',
    '#3E1C96',
  ],
  MAGENTA: [
    undefined,
    '#FDF2FA',
    '#FCE7F6',
    '#FCCEEE',
    '#FAA7E0',
    '#F670C7',
    '#EE46BC',
    '#DD2590',
    '#C11574',
    '#9E165F',
    '#851651',
  ],
  ADDITIONAL: [undefined, '#FEF1DA', '#906200', '#F8E1B6'],
};

// Light empty-state illustration fills (NoAvailableMessage icons): ground shadow, card body,
// inner panel, outline. The CDS light theme exposes them as palette.illustration.
export const ILLUSTRATION_FILLS = {
  shadow: '#EEF0F5',
  surface: '#F6F9FF',
  inner: '#E7EBF4',
  stroke: '#D3D9E4',
};

export const SECONDARY_COLOR = '#4D627B';

export const TagColor = {
  GREEN: 'green',
  BLUE: 'blue',
  YELLOW: 'yellow',
  PURPLE_DARK: 'purpleDark',
  INDIGO: 'indigo',
  RED: 'red',
  PURPLE_LIGHT: 'purpleLight',
  PINK: 'pink',
  ORANGE: 'orange',
  ORANGE_DARK: 'orangeDark',
  GREY_DARK: 'greyDark',
};

export const defaultBlockSizes = [DEFAULT_BLOCK_SIZES, DEFAULT_BLOCK_SIZES_2];

export const APP_HEADER_HEIGHT = '80';
export const APP_HEADER_HEIGHT_MOBILE = '56';

const ModalPopupDimensions = {
  TOP_MARGIN: 32,
  BOTTOM_MARGIN: 32,
  HEADER_HEIGHT: 64,
  FOOTER_HEIGHT: 54,
};

export const MODAL_BODY_DEFAULT_OFFSETS =
  ModalPopupDimensions.HEADER_HEIGHT +
  ModalPopupDimensions.TOP_MARGIN +
  ModalPopupDimensions.BOTTOM_MARGIN;

export const PHONE_NUMBER_FORMAT = '###-###-####';

export const EMPLOYER_IDENTIFICATION_NUMBER_FORMAT = '##-#######';

export const PHONE_NUMBER_WITH_CODE_FORMAT = '+1 (###) ###-####';

export const SSN_FORMAT = '###-##-####';

export const FHA_CASE_NUMBER_FORMAT = '###-#######';

export const ItemGroupAlignment = {
  HORIZONTAL: 'horizontal',
  VERTICAL: 'vertical',
};

export const ItemLabelPlacement = {
  START: 'start',
  END: 'end',
};

export const HORIZONTAL_ALIGNMENT = {
  CENTER: 'center',
  LEFT: 'left',
  RIGHT: 'right',
};

export const TABLE_CELL_ALIGNMENT = {
  INHERIT: 'inherit',
  JUSTIFY: 'justify',
  ...HORIZONTAL_ALIGNMENT,
};

export const LogoType = {
  DOCUMENTS: 'Documents',
  COMPANY: 'Company',
  FAVICON: 'Favicon',
  FOOTER_LEGAL_LOGO: 'FooterLegalLogo',
};

export const PosDocumentType = {
  E_CONSENT_POLICY: 'EConsentPolicy',
  TERMS_AND_CONDITIONS: 'TermsAndConditions',
  PRIVACY_POLICY: 'PrivacyPolicy',
  REVIEW_PAGE_DISCLOSURES: 'ReviewPageDisclosures',
  CREDIT_PROFILE_DOCUMENT: 'CreditProfileDocument',
};

export const PosDocumentTypeMap = {
  [PosDocumentType.E_CONSENT_POLICY]: 'eConcent', // be typo
  [PosDocumentType.TERMS_AND_CONDITIONS]: 'termsAndConditions',
  [PosDocumentType.PRIVACY_POLICY]: 'privacyPolicy',
  [PosDocumentType.REVIEW_PAGE_DISCLOSURES]: 'reviewPageDisclosuresSettings.link.value',
  [PosDocumentType.CREDIT_PROFILE_DOCUMENT]: 'creditProfileDocument',
};

export const LinkType = {
  FILE: 'File',
  EXTERNAL: 'External',
};

export const DRAWER_WIDTH = 'calc(100% - 220px)';

export const DRAWER_SMALL_WIDTH = '480px';

export const DRAWER_MEDIUM_WIDTH = '640px';

export const DRAWER_LARGE_WIDTH = '920px';

export const SCREEN_WIDTH = {
  S: 320,
  M: 768,
  L: 1024,
  L_WIDE: 1440,
  XL: 1920,
  ULTRAWIDE: 2560,
};

export const RESPONSIVE_PADDING = {
  MOBILE: '12px',
  TABLET: '16px',
  DESKTOP: '24px',
};

export const mediaQuery = {
  mobile: `@media (max-width: ${SCREEN_WIDTH.M - 1}px)`,
  tablet: `@media (min-width: ${SCREEN_WIDTH.M}px) and (max-width: ${SCREEN_WIDTH.L - 1}px)`,
  mobileAndTablet: `@media (max-width: ${SCREEN_WIDTH.L - 1}px)`,
  tabletAndUp: `@media (min-width: ${SCREEN_WIDTH.M}px)`,
  desktop: `@media (min-width: ${SCREEN_WIDTH.L}px)`,
  belowWideDesktop: `@media (max-width: ${SCREEN_WIDTH.L_WIDE - 1}px)`,
  wideDesktop: `@media (min-width: ${SCREEN_WIDTH.L_WIDE}px)`,
  belowLargeScreen: `@media (max-width: ${SCREEN_WIDTH.XL - 1}px)`,
};

/**
 * Geometry of the floating mobile bottom-nav bar (DefaultLayout/components/BottomNav). Shared so any
 * bottom-fixed element (e.g. the AI assistant launcher) can clear the bar instead of colliding with
 * it. HEIGHT = tab min-height (52) + 2× bar padding (8); GAP = the bar's distance from the viewport
 * bottom. The bar additionally offsets by `env(safe-area-inset-bottom)` at runtime.
 */
export const MOBILE_BOTTOM_NAV = {
  HEIGHT: 68,
  GAP: 12,
};

export const NON_BREAKING_SPACE = '\u00A0';

export const EM_DASH = '\u2014';

export const DEPRECATED_THEME_COLORS = {
  DARK: {
    50: '#e3e6e8',
    100: '#bac0c5',
    200: '#8c969f',
    300: '#5e6c78',
    400: '#3c4d5b',
    500: '#192d3e',
    600: '#162838',
    700: '#122230',
    800: '#0e1c28',
    900: '#08111b',
    A100: '#5b9aff',
    A200: '#287bff',
    A400: '#005ef4',
    A700: '#0054da',
  },
  SKY_BLUE: {
    50: '#ecfbff',
    100: '#d0f4fe',
    200: '#b0edfd',
    300: '#90e5fc',
    400: '#79e0fc',
    500: '#61dafb',
    600: '#59d6fa',
    700: '#4fd0fa',
    800: '#45cbf9',
    900: '#33c2f8',
    A100: '#ffffff',
    A200: '#ffffff',
    A400: '#d7f3ff',
    A700: '#beecff',
  },
};
